import apiClient from 'api/base';
import { FeatureToggles } from 'models/feature-toggling.model';

export const getFeatureToggles = async (): Promise<FeatureToggles> => {
  const { data } = await apiClient.get('/feature-toggling');

  return data;
};
